
interface LeftArrowInTabsMenuProps {
    color: string;
    onClick: () => void;
    isVisibleOnHover?: boolean;
    additionalClassName?: string;
    svgAdditionalClassName?: string;
    minHeight?: string;
    isArrowHidden?: boolean;
}

export const LeftArrowInTabsMenu = ({
    color, onClick,
    isVisibleOnHover = true,
    additionalClassName,
    svgAdditionalClassName,
    minHeight = '',
    isArrowHidden = false
}: LeftArrowInTabsMenuProps) => {
    return (
        <>
            {isArrowHidden ? null : (


                <div className={`flex justify-center items-center min-w-[16px] cursor-pointer 
            ${isVisibleOnHover ? 'opacity-100' : 'opacity-0'} 
            ${additionalClassName}
            ${minHeight}`}
                    onClick={onClick}
                >
                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${svgAdditionalClassName}`}>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.15077 0.240761C8.5701 0.600182 8.61866 1.23148 8.25924 1.65081L2.81707 8L8.25924 14.3492C8.61866 14.7685 8.5701 15.3998 8.15077 15.7592C7.73145 16.1187 7.10015 16.0701 6.74073 15.6508L0.740743 8.65079C0.419752 8.2763 0.419752 7.7237 0.740743 7.34921L6.74073 0.349226C7.10015 -0.070099 7.73145 -0.11866 8.15077 0.240761Z"
                            fill={color}
                        />
                    </svg>
                </div>
            )}
        </>
    )
}
